import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import "./assets/scss/cconsent-bar.css";
import Disclaimer from "./components/Disclaimer";

function App() {
    return (
        <>
            <nav className="header">
                <div className="top-row">
                    <a className="logo-wrapper" href="https://www.skoda-auto.pl/" target="_self"></a>
                </div>
                <div className="bottom-row">
                    <a href="https://www.skoda-auto.pl/" target="_self">Przejdź do&nbsp;strony głównej</a>
                </div>
            </nav>

            <div className="main-container">
                <h1 className="form-title">Poznaj ofertę dla Ciebie</h1>
                
                <div className="form-copy">
                    <p><b>Planujesz zakup nowej Škody?</b> <br/>Z chęcią skontaktujemy się z Tobą, by ustalić szczegóły bez wychodzenia z domu!</p>
                </div>

                <div className="form-wrapper">
                    <ServiceForm />
                    <Disclaimer />
                </div>

            </div>
        </>
    );
}

export default App;
